<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.212 2.705a.625.625 0 1 0-.925.84L4.791 5.2C1.953 6.941.733 9.625.679 9.747a.625.625 0 0 0 0 .508c.027.061.689 1.529 2.16 3 1.96 1.96 4.436 2.995 7.161 2.995a9.93 9.93 0 0 0 4.068-.846l1.719 1.891a.626.626 0 1 0 .925-.84l-12.5-13.75zM7.91 8.63l3.256 3.582A2.5 2.5 0 0 1 7.91 8.63zM10 15c-2.405 0-4.505-.874-6.245-2.598A10.404 10.404 0 0 1 1.953 10c.367-.687 1.536-2.609 3.7-3.858l1.406 1.543a3.75 3.75 0 0 0 4.973 5.469l1.15 1.265A8.75 8.75 0 0 1 10 15zm.469-7.455a.625.625 0 1 1 .234-1.229 3.762 3.762 0 0 1 3.029 3.332.625.625 0 0 1-1.045.518.625.625 0 0 1-.203-.405 2.507 2.507 0 0 0-2.015-2.216zm8.85 2.71c-.033.073-.825 1.825-2.607 3.422a.627.627 0 0 1-1.047-.499.626.626 0 0 1 .214-.433A10.371 10.371 0 0 0 18.05 10a10.4 10.4 0 0 0-1.806-2.404C14.504 5.874 12.404 5 10 5c-.507 0-1.013.04-1.513.123a.625.625 0 1 1-.206-1.233c.568-.094 1.143-.14 1.719-.14 2.725 0 5.2 1.036 7.16 2.996 1.472 1.471 2.134 2.94 2.161 3a.626.626 0 0 1 0 .509h-.002z"
      fill="currentColor"
    />
  </svg>
</template>
